import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Chapter, FadeUp, MaskedLines } from "@/components/motion";

const TYPES = [
  "TIENDAS",
  "RESTAURANTES",
  "PELUQUERÍAS",
  "CENTROS DE ESTÉTICA",
  "OFICINAS PEQUEÑAS",
  "COMERCIOS DE PROXIMIDAD",
];

export default function WhoFor() {
  return (
    <section className="relative py-32 lg:py-44 bg-abyss border-y border-silver/10" data-testid="section-para-quien">
      <div className="mx-auto max-w-[1500px] px-6 lg:px-12">
        <Chapter num="06" label="PARA QUIÉN" className="mb-12" />
        <h2 className="font-display font-800 uppercase leading-[0.98] tracking-tight text-4xl sm:text-6xl lg:text-7xl text-offwhite mb-16">
          <MaskedLines
            mode="view"
            lines={[
              <span key="a">Pensada para pequeños</span>,
              <span key="b">
                <span className="font-cormorant normal-case font-medium text-metal">comercios</span> con local físico.
              </span>,
            ]}
          />
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-silver/10">
          {TYPES.map((t, i) => (
            <FadeUp key={t} delay={i * 0.05} y={20}>
              <div className="group relative border-b border-r border-silver/10 p-8 md:p-10 h-full hover:bg-panel/60 transition-colors duration-500">
                <span className="font-mono text-[10px] tracking-[0.3em] text-steel block mb-8">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="font-oswald font-500 uppercase text-xl md:text-2xl tracking-wide text-mist group-hover:text-offwhite transition-colors duration-300">
                  {t}
                </span>
                <span className="absolute bottom-8 right-8 h-1.5 w-1.5 rotate-45 bg-glow/0 group-hover:bg-glow/70 transition-colors duration-500" />
              </div>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={0.2} className="mt-14 flex flex-wrap items-center justify-between gap-8">
          <p className="text-mist max-w-md leading-relaxed">
            Si tu negocio depende de un local que funciona, esto está pensado para ti.
          </p>
          <Link
            to="/para-comercios"
            data-testid="who-for-link"
            className="group inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.25em] text-mist hover:text-silver transition-colors duration-300"
          >
            VER PARA COMERCIOS
            <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </FadeUp>
      </div>
    </section>
  );
}
